export default __webpack_public_path__ + "97e96c72fd7b7178dabde46ffa77cbc8.png";